// extracted by mini-css-extract-plugin
export default {"text":"Registros_text__aeUx2"};